const clientDesktop = require('./desktop/client-desktop')

export function start(settingsData) {
	// console.log('clients @@@@@@@@@@@@@@@@  >', settingsData)

	clientDesktop.start(settingsData)

}/**/